import React, { useState, useRef } from 'react';
import axios from 'axios';

export default function Write() {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    url: '', 
    category1: '0', // 기본값은 '자주 묻는 질문'
  });

  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 입력 필드 변경 핸들러
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }

    if (!formData.content.trim()) {
      alert('내용을 입력해주세요.');
      return;
    }

    console.log('제출할 데이터:', formData);

    setIsSubmitting(true);

    try {
      const formDataForSubmit = new FormData();

      formDataForSubmit.append('title', formData.title);
      formDataForSubmit.append('content', formData.content);
      
      // 카테고리가 1(자가관리방법)인 경우에만 URL 추가
      if (formData.category1 === '1') {
        formDataForSubmit.append('url', formData.url || ''); 
      }
      
      formDataForSubmit.append('category1', formData.category1);

      // 파일이 선택되었는지 확인하고 추가 (카테고리가 1인 경우에만)
      if (formData.category1 === '1' && fileInputRef.current && fileInputRef.current.files[0]) {
        const file = fileInputRef.current.files[0];
        
        // 파일 크기 검증 (5MB 제한)
        if (file.size > 5 * 1024 * 1024) {
          alert('파일 크기는 5MB를 초과할 수 없습니다.');
          setIsSubmitting(false);
          return;
        }
        
        formDataForSubmit.append('file', file); 
        console.log('파일 추가됨:', file.name);
      }

      console.log('전송할 FormData 내용:');
      for (let pair of formDataForSubmit.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      const response = await axios.post(
        '/api/admin/insertFaqVideo',
        formDataForSubmit,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        alert('FAQ가 성공적으로 등록되었습니다.');
        window.location.href = '/admin/faq';
      } else {
        alert(response.data.message || 'FAQ 등록에 실패했습니다.');
      }
    } catch (error) {
      alert('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      console.error('폼 제출 오류:', error);
      if (error.response) {
        console.error('응답 데이터:', error.response.data);
        console.error('응답 상태:', error.response.status);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="titleNav">FAQ 등록</div>
        <div className="wrap">
          <div className="over_hi" style={{ marginTop: '60px' }}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <table className="adminTable">
                <tbody>
                  <tr>
                    <th style={{ width: '200px' }}>카테고리</th>
                    <td className="left">
                      <div>
                        <label style={{ marginRight: '20px' }}>
                          <input
                            type="radio"
                            name="category1"
                            value="0"
                            checked={formData.category1 === '0'}
                            onChange={handleChange}
                            style={{ marginRight: '5px' }}
                          />
                          자주 묻는 질문
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="category1"
                            value="1"
                            checked={formData.category1 === '1'}
                            onChange={handleChange}
                            style={{ marginRight: '5px' }}
                          />
                          자가관리방법
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>제목</th>
                    <td className="left">
                      <input
                        type="text"
                        name="title"
                        id="title"
                        value={formData.title}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        placeholder={formData.category1 === '0' ? "FAQ 제목을 입력하세요" : "자가관리방법 제목을 입력하세요"}
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>내용</th>
                    <td className="left">
                      <textarea
                        name="content"
                        id="content"
                        style={{ 
                          width: '100%', 
                          height: '300px', 
                          padding: '8px',
                          resize: 'vertical',
                          fontFamily: 'inherit'
                        }}
                        value={formData.content}
                        onChange={handleChange}
                        placeholder={formData.category1 === '0' ? "FAQ 내용을 입력하세요" : "자가관리방법 내용을 입력하세요"}
                        required
                      ></textarea>
                    </td>
                  </tr>
                  
                  {/* 카테고리가 1(자가관리방법)인 경우에만 표시 */}
                  {formData.category1 === '1' && (
                    <>
                      <tr>
                        <th style={{ width: '200px' }}>유튜브 URL</th>
                        <td className="left">
                          <input
                            type="url"
                            name="url"
                            id="url"
                            value={formData.url}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px' }}
                            placeholder="유튜브 링크를 입력해주세요."
                          />
                        </td>
                      </tr>
                      <tr>
                        <th style={{ width: '200px' }}>
                          첨부파일<br />(~5MB)
                        </th>
                        <td className="left">
                          <input
                            type="file"
                            name="file"
                            id="file"
                            ref={fileInputRef}
                            accept="image/*,.pdf,.doc,.docx,.hwp,.txt"
                          />
                          <small style={{ color: '#666', marginLeft: '10px' }}>
                            (최대 5MB)
                          </small>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
              <div className="right" style={{ marginTop: '20px' }}>
                <button
                  type="button"
                  className="common-del"
                  onClick={() => (window.location.href = '/admin/faq')}
                  style={{ marginRight: '10px' }}
                >
                  목록으로
                </button>
                <button
                  type="submit"
                  className="common-del"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '등록 중...' : '등록하기'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}